import { render, staticRenderFns } from "./CouponPage.vue?vue&type=template&id=11c3b621&scoped=true&"
import script from "./CouponPage.vue?vue&type=script&lang=js&"
export * from "./CouponPage.vue?vue&type=script&lang=js&"
import style0 from "./CouponPage.vue?vue&type=style&index=0&id=11c3b621&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c3b621",
  null
  
)

export default component.exports